import ActivityLog from '../components/ActivityLog/ActivitiesLog';

export const DEFAULT_ACTIONS = ({ activityProps = {} }) => [
  {
    hasExport: true,
    ...activityProps,
    id: 'activity',
    name: 'Activity',
    icon: 'activity-log-mono',
    color: 'primary-500',
    component: <ActivityLog />
  }
];
